if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
          element.style.display = 'none'; // Hide inactive images
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia ? activeMedia.querySelector('template') : null;
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        if (activeMedia) {
          activeMedia.classList.add('active');
          activeMedia.style.display = ''; // Show active image
          activeMedia.scrollIntoView();
        }

        const container = this.querySelector('[role="document"]');
        if (activeMedia) {
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

          if (
            activeMedia.nodeName == 'DEFERRED-MEDIA' &&
            activeMediaContent &&
            activeMediaContent.querySelector('.js-youtube')
          ) {
            activeMedia.loadContent();
          }
        }
      }
    }
  );
}
